import React from 'react'
import image_1 from '../../CustomAssets/Images/HomePage/vector_images/image_1.svg'; 
import image_2 from '../../CustomAssets/Images/HomePage/vector_images/image_2.svg'; 
import image_3 from '../../CustomAssets/Images/HomePage/vector_images/image_3.svg'; 
import image_4 from '../../CustomAssets/Images/HomePage/vector_images/image_4.svg'; 
import image_5 from '../../CustomAssets/Images/HomePage/vector_images/image_5.svg'; 
import image_6 from '../../CustomAssets/Images/HomePage/vector_images/image_6.svg'; 
import flag from '../../CustomAssets/Images/HomePage/flag.png'; 

export function Img1() {
  return (
    <img decoding="async" className="unset" src={image_1} alt="Image" />
  );
}
export function Img2() {
  return (
    <img decoding="async" className="unset" src={image_2} alt="Image" />
  );
}
export function Img3() {
  return (
    <img decoding="async" className="unset" src={image_3} alt="Image" />
  );
}
export function Img4() {
  return (
    <img decoding="async" className="unset" src={image_4} alt="Image" />
  );
}
export function Img5() {
  return (
    <img loading="lazy" decoding="async" className="attachment-large size-large wp-image-754" width="640" height="425" src={image_5} alt="Image" />
  );
}
export function Img6() {
  return (
    <img loading="lazy" decoding="async" className="attachment-large size-large wp-image-754" width="640" height="425" src={image_6} alt="Image" />
  );
}

export function IndFlag() {
  return (
    <img loading="lazy" decoding="async" className="flag" src={flag} alt="Image" />
  );
}